import { createContext } from "react";

export function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export function readCurrentState(field){
    var localData = localStorage.getItem('SWINS-State');
    if (localData==undefined){
        return '';
    }
    var Data = JSON.parse(localData);
    if (Data==undefined){
        return '';
    }
    let res = Data[field];
    if(res==undefined){
        console.warn('readCurrentState field: '+field+' not found!')
        return '';
    }else{
        return Data[field];
    }

}
export function sendCurrentState() {
    localStorage.setItem('SWINS-State', JSON.stringify(StepContext.contratto));

    //console.log(StepContext.contratto);

    fetch(process.env.REACT_APP_API_URL+`contratti/`,
            {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(StepContext.contratto)
            })
            .then(response => {
                if(response.ok){
                    console.log(response);
                    //return response.json()
                }else{
                    throw new Error('Error...')
                }
            }
            )
            .then(data => {
               // console.log(data);                
            }
            ).catch(
                (error)=> {console.error(error);}
            )
}

export const StepContext = createContext({
    step: 1,
    setStep: (s) => { },
    contratto: {},
    setContratto: function (x) {
        console.log(x);
    }
});
